<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper" v-has="'projectUser:management'">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="研究中心" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-select placeholder="请选择研究中心" v-model="queryParam.centerId" >
                <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.center.id">
                  {{ item.center.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="角色" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-select placeholder="请选择角色" v-model="queryParam.roleId" >
                <a-select-option v-for="(item,index) in roleList" :key="index" :value="item.id">
                  {{ item.roleName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-item label="姓名/帐号" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input placeholder="请输入姓名/帐号" v-model="queryParam.value" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6" style="text-align: left" >
            <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
            <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            <a-button type="primary" @click="handleAddMy" icon="plus" style="margin-left: 8px">新增</a-button>
            <a-upload name="file" :data="{projectId:projectId}" :showUploadList="false" :multiple="false" :headers="tokenHeader" style="margin-left: 8px" :action="importExcelUrl" @change="handleImportExcel">
              <a-button type="primary" v-has="'projectUser:import'">批量导入</a-button>
            </a-upload>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table :columns="columns"
             size="small"
             :scroll="{y:'600px'}"
             :dataSource="dataSource"
             :pagination="ipagination"
             :loading="loading"
             @change="handleTableChange">
      >
      <span slot="roleList" slot-scope="text,record,index">

        <a-tooltip>
          <template slot="title">
            {{getRoleNameList(record.roleList)}}
          </template>
          {{getRoleNameList(record.roleList)}}
        </a-tooltip>
      </span>
      <span slot="action" slot-scope="text,record,index">
        <a @click="handleEditRole(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm v-if="record.status==1" title="确定冻结该账号吗?" @confirm="() => handleFrozen(record.userId,2,record.username)">
          <a>冻结</a>
        </a-popconfirm>
        <a-popconfirm v-else title="确定要解冻该账号吗?" @confirm="() => handleFrozen(record.userId,1,record.username)">
          <a>解冻</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a-popconfirm title="确定移出项目吗?" @confirm="() => handleDelete(record.id)">
          <a>移出项目</a>
        </a-popconfirm>
        <a-divider type="vertical" v-has="'projectUser:resetpwd'" />
        <a-popconfirm v-has="'projectUser:resetpwd'" title="确定重置密码吗?" @confirm="() => handleReset(record)">
          <a>重置密码</a>
        </a-popconfirm>
        <a-divider type="vertical" v-has="'projectUser:setpwd'" />
        <a v-has="'projectUser:setpwd'" href="javascript:;" @click="handleChangePassword(record.username)">设置密码</a>
      </span>
    </a-table>
    <a-modal
      title="成员信息"
      :width="820"
      :visible="formVisible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel">
      <div style="padding: 0px 70px 20px 70px;">
        <label >研究中心：</label>
        <a-select placeholder="请选择研究中心" v-model="modelSearch.centerId" style="width: 200px" allowClear>
          <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.centerId">
            {{ item.center.name }}
          </a-select-option>
        </a-select>
        <!-- <label style="margin-left: 20px">姓名/帐号：</label>
        <a-input placeholder="请输入帐号" v-model="modelSearch.input" style="width: 200px;" ></a-input>
        <a-button icon="search" style="margin-left: 20px" @click="userSearch"></a-button> -->
      </div>
      <a-form-model :model="formData" layout="horizontal" style="padding-left: 20px;padding-right: 20px;"
                    v-bind="{labelCol: { span:4 }, wrapperCol: { span: 16 },}" ref="userForm">
       <a-form-model-item label="成员帐号" prop="username" :rules="[{ required: true, message: '请输入成员帐号' }, { validator: validateUsername, trigger: 'blur' }]">
        <a-input placeholder="请输入成员帐号" v-model="formData.username" style="width: 200px;" @blur="handleUser" ></a-input>
        </a-form-model-item>
        <a-form-model-item label="成员姓名" prop="realname"  :rules="[{ required: true, message: '请输入成员姓名' }]">
            <a-input placeholder="请输入成员姓名" v-model="formData.realname" style="width: 200px;" ></a-input>
          <!-- <label style="color:red;margin-left: 20px" v-show="isInProject">已存在于本项目中</label> -->
        </a-form-model-item>
        <a-form-model-item label="性别" prop="sex" :rules="[{ required: true, message: '请选择性别' }]">
          <a-select v-model="formData.sex" placeholder="请选择性别" :getPopupContainer="(target) => target.parentNode" style="width: 200px;">
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="0">女</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="phone" :rules="[{ required: true, message: '请输入联系电话' },{ pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码' }]">
           <a-input placeholder="请输入联系电话" v-model="formData.phone" style="width: 200px;" ></a-input>
        </a-form-model-item>
         <a-form-model-item label="邮箱地址" prop="email"  :rules="[{ required: true, message: '请输入邮箱地址' },{ type: 'email', message: '请输入有效的邮箱地址' }]">
           <a-input placeholder="请输入邮箱地址" v-model="formData.email" style="width: 200px;" ></a-input>
        </a-form-model-item>

        <a-form-model-item label="角色" prop="roleList" :rules="[{ required: true, message: '请选择至少一个角色', trigger: 'change' }]">
          <a-checkbox-group v-model="formData.roleList">
            <a-row style="width: 600px">
              <a-col :span="8" v-has="'projectUser:role:' + role.roleCode" v-for="(role, index) in otherRoleList" :key="role.id">
                <a-checkbox :value="role.id">
                  {{role.roleName}}
                </a-checkbox>
              </a-col>
              <template>
                <a-col :span="8" v-for="(role, index) in projectRoleList" :key="role.id">
                  <a-checkbox :value="role.id">
                    {{role.roleName}}
                  </a-checkbox>
                </a-col>
              </template>              
            </a-row>
          </a-checkbox-group>
        </a-form-model-item>

      </a-form-model>
    </a-modal>
     <password-modal ref="passwordmodal"></password-modal>
  </a-card>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import { USER_INFO } from "@/store/mutation-types"
  import {frozenBatch} from '@/api/api'
  import Vue from 'vue'
  import PasswordModal from '@/views/system/modules/PasswordModal'

  export default {
    name: 'Person',
    mixins:[JeecgListMixin],
     components: {  
      PasswordModal,
    },
    data(){
      return {
        modelSearch:{
          centerId:undefined,
          input:undefined
        },
        columns:[
          {
            title: '研究中心',
            align:'center',
            dataIndex: 'centerName',
            width: 150,
          },
          {
            title: '姓名',
            align:'center',
            dataIndex: 'realname',
            width: 100,
          },
          {
            title: '帐号',
            align:'center',
            dataIndex: 'username',
            width: 150,
          },
          {
            title: '角色',
            align:'center',
            dataIndex: 'roleList',
            ellipsis: true,// 表格省略
            scopedSlots: { customRender: 'roleList' },
            width: 200,
          },
           {
            title: '邮箱',
            align:'center',
            dataIndex: 'email',
            width: 150,
          },
          {
            title: '状态',
            align:'center',
            dataIndex: 'status_dictText',
            width: 100,
          },
         
          {
            title: '操作',
            align:'center',
            width: 250,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          }
        ],
        disableMixinCreated:true,
        url: {
          list: "/project/projectUser/list",
          delete:'/project/projectUser/delete'
        },
        formVisible:false,
        confirmLoading:false,
        formData:{},
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        roleList:[],
        centerList:[],
        isEdit:false,
        isInProject:false,
      }
    },
    computed: {
      projectRoleList() {
        console.log("projectRoleList")
        let user = Vue.ls.get(USER_INFO)
        return this.roleList.filter(item =>
          item.enableProjectId &&item.enableProjectId.indexOf(this.projectId) > -1 &&
          item.enableCenterId && item.enableCenterId.indexOf(user.centerId) > -1
    );
      },
      otherRoleList(){
        return this.roleList.filter(item=>{
          return !item.enableProjectId
        })
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/project/projectUser/importExcel`;
      }
    },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
      getAction('/sys/role/listAll',{type:'0'}).then(res=>{
        if(res.success){
          this.roleList = res.result
        }
      })
      getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
        if(res.success){
          this.centerList = res.result
          if(this.centerList&&this.centerList.length>0){
            this.modelSearch.centerId = this.centerList[0].centerId
          }
        }
      })
    },
    methods:{
      validateUsername(rule, value, callback) {
        if (!value) {
            return callback();
          }
        if(this.isEdit){
          return callback();
        }
        getAction('/project/projectUser/userInProject', {userName: value,projectId: this.projectId,centerId: this.modelSearch.centerId}).then(res => {
              if (res && res.success) {
                callback(new Error('该帐号已存在于当前研究中心'));
              } else {
                callback();
              }
            }).catch(error => {
              console.error('接口调用失败:', error);
              callback(new Error('验证失败，请稍后再试'));
            });
      },

      handleUser(){
        console.log(this.formData.username)
        let that = this;
        getAction('/sys/user/byUserName', {userName: that.formData.username}).then(res => {
              var data = {}
              if (res && res.success) {
                data = {
                  sex: res.result.sex,
                  realname: res.result.realname,
                  phone: res.result.phone,
                  email: res.result.email,
                }             
              } else {
                data = {
                  sex: null,
                  realname: null,
                  phone: null,
                  email: null,                  
                }
              }            
            that.formData = { ...that.formData, ...data };
            }).catch(error => {
              
            });
      },

      handleReset(record){
        if(record.email==null || record.email.trim() == ''){
          return this.$message.warning('邮箱地址为空或者格式不对！')
        }
        getAction('/project/projectUser/resetPassword', {userId: record.userId}).then(res => {
              if (res.success) {
              this.$message.success('密码重置成功！')
              } else {
                 this.$message.warning('密码重置失败！')
              }
            })
      },
  
      userSearch(){
        if(!this.modelSearch.centerId || !(this.modelSearch.input && this.modelSearch.input.trim())){
          return this.$message.warning('请输入完整条件进行检索！')
        }
        const params = Object.assign({},this.modelSearch);
        params.projectId = this.projectId
        // this.modelSearch.username=this.modelSearch.input
        this.confirmLoading = true
        this.isInProject = false

        getAction('/project/projectUser/searchByInfo',params).then(res=>{
          if(res.success){
            if(res.result){
              this.formData = {
                roleList:res.result.roleList,
                centerId:res.result.centerId,
                userId:res.result.id,
                username:res.result.username,
                realname:res.result.realname,
                phone:res.result.phone
              }
              getAction('/project/projectUser/isInProject',{userId:this.formData.userId,projectId:this.projectId}).then(res=>{
                if(res.success){
                  this.isInProject = res.result
                }
              }).finally(()=>{
                this.confirmLoading = false
              })
            }else{
              this.$message.warning('未查询到结果')
            }
          }
        }).finally(()=>{
          this.confirmLoading = false
        })
      },
      handleAddMy(){
        this.isEdit = false
        this.formData = {}
        this.formVisible = true
        this.isInProject = false
      },
      handleEditRole(record){
        this.isEdit = true
        this.formData = Object.assign({},record)
        this.formVisible = true
        this.isInProject = false
        this.modelSearch.centerId= this.formData.centerId
      },

      handleSubmit(){
        this.$refs.userForm.validate((valid) => {
        if (valid) {      
        // if(!this.formData.roleList || this.formData.roleList.length===0){
        //   return this.$message.warning('请选择角色！')
        // }
          // 提交表单
         const params ={
          projectId:this.projectId,
          centerId:this.modelSearch.centerId,
          userId:this.formData.userId,
          roleList:this.formData.roleList,
          id:this.formData.id,
          sex:this.formData.sex,
          realname:this.formData.realname,
          username:this.formData.username,
          phone:this.formData.phone,
          email:this.formData.email,
        }        
        if(this.isEdit){
          params.id = this.formData.id
        }
        this.confirmLoading = true
        postAction('/project/projectUser/saveOrUpdate',params).then(res=>{
          if(res.success){
            this.loadData()
            this.handleCancel()
          }else{
            this.$message.warning(res.message)
          }
          
        }).finally(()=>{
          this.confirmLoading = false
        })
        } else {
          console.log('表单验证失败');
        }
      });

        
      },
      handleCancel(){
        this.formVisible = false
      },
      getRoleNameList(roleIdList){
        let result=''
        if(roleIdList){
          roleIdList.forEach(id=>{
            const role = this.roleList.filter(role=> role.id===id);
            if(role.length>0){
              result +=role[0].roleName+','
            }
          })
        }
        if(result.length>0){
          result = result.substring(0,result.length-1)
        }
        return result
      },
      handleFrozen(id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          return that.$message.warning('管理员账号不允许此操作！');
        }
        frozenBatch({ids: id, status: status}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
       handleChangePassword(username) {
        this.$refs.passwordmodal.show(username);
      },
    }
  }
</script>

<style scoped>

</style>